import { AdvanceShareStyleAssetDefinition, AdvanceShareStylePolicyDefinition, AdvanceShareStyleRenderingConfigDefinition, AdvanceShareStyleUsageRuleDefinition, AdvanceShareStyleVariableDefinition } from "./advance-share-style-definition.model";
import { BaseLookupModel, PaginationFilterRequest } from "./core.model";

export interface AdvanceShareStyleVersion {
    id: number;
    styleId: number;
    version?: number;
    promptTemplate: string;
    status: AdvanceShareStyleVersionStatusEnum;
    assets: AdvanceShareStyleAssetDefinition[];
    variables: AdvanceShareStyleVariableDefinition[];
    policies: AdvanceShareStylePolicyDefinition[];
    renderingConfig: AdvanceShareStyleRenderingConfigDefinition;
    usageRules: AdvanceShareStyleUsageRuleDefinition[];
    style: BaseLookupModel;
}

export interface UpsertAdvanceShareStyleVersion {
    id?: number;
    styleId?: number;
    promptTemplate?: string;
    assets?: AdvanceShareStyleAssetDefinition[];
    variables?: AdvanceShareStyleVariableDefinition[];
    policies?: AdvanceShareStylePolicyDefinition[];
    renderingConfig?: AdvanceShareStyleRenderingConfigDefinition;
    usageRules?: AdvanceShareStyleUsageRuleDefinition[];
}


export class AdvanceShareStyleVersionPaginationFilterRequest extends PaginationFilterRequest{  
    styleId?: number;
    status?: AdvanceShareStyleVersionStatusEnum;
}


export enum AdvanceShareStyleVersionStatusEnum
{
    Draft = 1,
    Published = 2,
    Archived = 3,
}

export const AdvanceShareStyleVersionStatusList = 
[
    { value: 1, label: "Draft" },
    { value: 2, label: "Published" },
    { value: 3, label: "Archived" },
];
